import React from "react";

const WhatsNewButton = ({ onClick, hasUnseen }) => {
  return (
    <div className="ms-1 header-item d-none d-sm-flex">
      <button
        onClick={onClick}
        type="button"
        className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none position-relative"
      >
        <i className="ri-gift-line fs-22"></i>
        {hasUnseen ? <span className="whats-new-badge-dot"></span> : null}
      </button>
    </div>
  );
};

export default WhatsNewButton;
